import { render } from "./DisplayPosts.vue?vue&type=template&id=0b793278"
import script from "./DisplayPosts.vue?vue&type=script&lang=js"
export * from "./DisplayPosts.vue?vue&type=script&lang=js"

import "./DisplayPosts.vue?vue&type=style&index=0&id=0b793278&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__